<ng-container *ngIf="loading">
  <div class="loading">
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
  </div>
</ng-container>
<ng-container *ngIf="!loading && role === 'CUSTOMER'">
  <div class="view-account" style="margin-left:20px;">
    <h1>User Profile</h1>
      <form>
        <div>
          <div id="left">
            <fieldset>
              <br>
              <div>
                <h3>Company Info</h3>
                  <div class="row">
                    <div class="col-md-5" >
                      <div class="details-left-bg">
                        <br>
                        <div class="details-left">
                          <ul>
                            <li>User ID </li> <br>
                            <li>Company Name</li> <br>
                            <li>Country</li> <br>
                            <li>Company Phone</li> <br>
                            <li>Company Email</li> <br>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-5" >
                      <div class="details-right-bg">
                        <br>
                        <div class="detail-right">
                          <ul>
                            <li>{{userDetails.userName}}</li> <br>
                            <li>{{userDetails.companyName}}</li> <br>
                            <li>{{userDetails.country}}</li> <br>
                            <li>{{userDetails.contactNumber}}</li> <br>
                            <li>{{userDetails.email}}</li> <br>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
            </fieldset>
            <fieldset>
              <div>
                <br>
                <h3 class="fieldset-title green">Contact Info</h3>
                <div class="row">
                  <div class="col-md-5" >
                    <div class="details-left-bg">
                      <br>
                      <div class="details-left">
                        <ul>
                          <li>Contact Person </li> <br>
                          <li>Phone Number </li> <br>
                          <li>E-mail</li> <br>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="details-right-bg">
                      <br>
                      <div class="detail-right">
                        <ul>
                          <li>{{userDetails.fullName}}</li> <br>
                          <li>{{userDetails.pContactNumber}}</li> <br>
                          <li>{{userDetails.pEmail}}</li> <br>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
            <fieldset>
              <div *ngIf="paymentDetails">
                <br>
                <h3 class="fieldset-title green">Payment Info</h3>
                <div class="row">
                  <div class="col-md-5" >
                    <div class="details-left-bg">
                      <br>
                      <div class="details-left">
                        <ul>
                          <li>AMC </li> <br>
                          <li>Current Credit </li> <br>
                          <li>Minimum Credit</li> <br>
                          <li>Credit per Transaction</li> <br>
                          <li>Credit per Support</li> <br>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="details-right-bg">
                      <br>
                      <div class="detail-right">
                        <ul>
                          <li>{{paymentDetails.AMC}}</li> <br>
                          <li>{{paymentDetails.credit}}</li> <br>
                          <li>{{paymentDetails.minCredit}}</li> <br>
                          <li>{{paymentDetails.perTransactionCredit}}</li> <br>
                          <li>{{paymentDetails.support}}</li> <br>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
          <div style="margin-right:20px;">
            <fieldset>
              <br>
              <div class="row">
              <h3>License and Bank Details</h3>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="details-left-bg">
                    <br>
                    <div class="details-left">
                      <ul>
                        <li>License Code </li> <br>
                        <li>GST Number </li> <br>
                        <li>PAN</li> <br>
                        <li>Currency</li> <br>
                        <li>Bank Name</li> <br>
                        <li>Bank Account Number</li> <br>
                        <li>IFSC Code</li> <br>
                        <li>SWIFT</li> <br>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="details-right-bg">
                    <br>
                    <div class="detail-right">
                      <ul>
                        <li>{{userDetails.licenseCode}}</li> <br>
                        <li>{{userDetails.gstNumber}}</li> <br>
                        <li>{{userDetails.PAN}}</li> <br>
                        <li>{{userDetails.currency}}</li> <br>
                        <li>{{userDetails.bankName}}</li> <br>
                        <li>{{userDetails.bankAccountNumber}}</li> <br>
                        <li>{{userDetails.IFSC}}</li> <br>
                        <li>{{userDetails.SWIFT}}</li> <br>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
        <br>
        <br>
        <hr>

        <div id="my_centered_buttons">
          <!-- <input class="btn btn-danger" type="submit" (click)="onLogout()" value="Log out"> -->
        </div>
        <br><br>
      </form>
  </div>
</ng-container>

<ng-container *ngIf="role === 'MODERATOR'">

    <div class="view-account" style="margin-left:20px;">
    <h1>User Profile</h1>
      <form>
        <div>
          <div>
            <fieldset>
              <br>
              <div>
                <h3>Personal Info</h3>
                  <div class="row">
                    <div class="col-md-5" >
                      <div class="details-left-bg">
                        <br>
                        <div class="details-left">
                          <ul>
                            <li>User ID </li> <br>
                            <li>Full Name </li> <br>
                            <!-- <li>Domain </li> <br> -->
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-5" >
                      <div class="details-right-bg">
                        <br>
                        <div class="detail-right">
                          <ul>
                            <li>{{userDetails.userName}}</li> <br>
                            <li>{{userDetails.fullName}}</li> <br>
                            <!-- <li>{{userDetails.domainName}}</li> <br> -->
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
            </fieldset>
            <fieldset>
              <div>
                <br>
                <h3 class="fieldset-title green">Contact Info</h3>
                <div class="row">
                  <div class="col-md-5" >
                    <div class="details-left-bg">
                      <br>
                      <div class="details-left">
                        <ul>
                          <li>Phone Number </li> <br>
                          <li>E-mail</li> <br>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="details-right-bg">
                      <br>
                      <div class="detail-right">
                        <ul>
                          <li>{{userDetails.contactNumber}}</li> <br>
                          <li>{{userDetails.email}}</li> <br>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>

        </div>
        <hr>
        <!-- <div id="my_centered_buttons ">
          <input class="btn btn-danger" type="submit" (click)="onLogout()" value="Log out">
        </div> -->
        <br><br>
  </form>
    </div>
</ng-container>

<ng-container *ngIf="role === 'TECHEXPERT'">
  <div class="view-account" style="margin-left:20px;">
    <h1>User Profile</h1>
      <form>
        <div>
          <div id="left">
            <fieldset>
              <br>
              <div>
                <h3>Personal Info</h3>
                  <div class="row">
                    <div class="col-md-5" >
                      <div class="details-left-bg">
                        <br>
                        <div class="details-left">
                          <ul>
                            <li>User ID </li> <br>
                            <li>Full Name </li> <br>
                            <li>Domain</li> <br>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-5" >
                      <div class="details-right-bg">
                        <br>
                        <div class="detail-right">
                          <ul>
                            <li>{{userDetails.userName}}</li> <br>
                            <li>{{userDetails.fullName}}</li> <br>
                            <li>{{userDetails.domainName}}</li> <br>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
            </fieldset>
            <fieldset>
              <div>
                <br>
                <h3 class="fieldset-title green">Contact Info</h3>
                <div class="row">
                  <div class="col-md-5" >
                    <div class="details-left-bg">
                      <br>
                      <div class="details-left">
                        <ul>
                          <li>Phone Number </li> <br>
                          <li>E-mail</li> <br>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="details-right-bg">
                      <br>
                      <div class="detail-right">
                        <ul>
                          <li>{{userDetails.contactNumber}}</li> <br>
                          <li>{{userDetails.email}}</li> <br>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
          <div style="margin-right:20px;">
            <fieldset>
              <br>
              <div class="row">
              <h3>License and Bank Details</h3>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="details-left-bg">
                    <br>
                    <div class="details-left">
                      <ul>
                        <li>PAN</li> <br>
                        <li>Bank Name</li> <br>
                        <li>Bank Account Number</li> <br>
                        <li>IFSC Code</li> <br>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="details-right-bg">
                    <br>
                    <div class="detail-right">
                      <ul>
                        <li>{{userDetails.PAN}}</li> <br>
                        <li>{{userDetails.bankName}}</li> <br>
                        <li>{{userDetails.bankAccountNumber}}</li> <br>
                        <li>{{userDetails.IFSC}}</li> <br>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
        <br><br><br><br><br><br><br>

        <hr>

        <!-- <div id="my_centered_buttons">
          <input class="btn btn-danger" type="submit" (click)="onLogout()" value="Log out">
        </div> -->
        <br><br>
      </form>
    </div>
</ng-container>

